// extracted by mini-css-extract-plugin
module.exports = {"title":"NoneData_title_1fnFi"};